import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Spin, Table, Input, Select } from 'antd';
import { CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import { SearchOutlined, RedoOutlined } from '@ant-design/icons';
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import trans from './translation';
import PropTypes from 'prop-types';//props传参检查库
import Message from '../../component/message/message';

const { Option } = Select;

const SelectProgramme = (props) => {

    const messageRef = useRef();
    const [selectedRowKeys, setSelectedRowKeys] = useState([]);
    const [checkboxState, setCheckboxState] = useState(props.checkboxState);
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0); //总条数
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [deptList, setDeptList] = useState([]);
    const [searchModel, setSearchModel] = useState({});
    const [oldSearchModel, setOldSearchModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);

    useEffect(() => {
        searchAllDept();
        search(pageSize, 1, "N");
    }, []);

    const searchAllDept = () => {
        if (Config.funcInfo.canSelect === "N") {
            return;
        }
        Base.callBackApi("commonDropDown/searchAllDept").then((data) => {
            if ("SUCCESS" === data.msg) {
                setDeptList(data.object ?? [])
            } else {
                errFrameShow("error", data.msg);
            }
        })
    }

    const search = (pageSizeNew, currentPageNew, flag, isShowMsg) => {
        messageShowHandler();  // 清除提示信息
        clearSelect(); // 清除选中状态
        let model = {};
        if ("Y" === flag) {     // 翻页
            model = oldSearchModel;
        } else {
            model = searchModel;
        }
        model.pageSize = pageSizeNew;
        model.startRow = (current - 1) * pageSizeNew;
        model.page = currentPageNew;
        setIsLoad(true);
        Base.callBackApi("programme/search", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                if (!data?.object?.list && isShowMsg) {
                    errFrameShow("info", trans.noneDate[Config.backLang]);
                }
                if ("N" === flag) {
                    setOldSearchModel(JSON.parse(JSON.stringify(model)));
                }
                setTablesCount(data?.object?.total ?? 0);
                setTables(data?.object?.list ?? []);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                errFrameShow("error", data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const searchChange = (key, value) => {
        setSearchModel(model => {
            return { ...model, ...{ [key]: value } };
        });
    }

    const reset = () => {
        messageShowHandler();
        setSearchModel({});
        setOldSearchModel({});
        setTablesCount(0);
        setTables([]);
        setPageSize(10);
    }

    const save = () => {
        if (checkboxState == null || checkboxState.length == 0) {
            errFrameShow("error", trans.pleaseSelectAtLeastOneRecord[Config.backLang]);
            return;
        }
        props.onClose(true, checkboxState);
    }

    const errFrameShow = (style, msg) => {
        messageRef.current.setStyle(style);
        messageRef.current.setContent(msg);
        messageRef.current.setIsShow(true);
        document.documentElement.scrollTop = 0;
    }

    const messageShowHandler = () => {
        messageRef.current.setIsShow(false);
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, currentNew, "Y");
    }
    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        search(pageSizeNew, 1, "Y");
    }

    const onSelectChange = (selectedRowKeys, selectedRows) => {
        setSelectedRowKeys(selectedRowKeys);
        setCheckboxState(selectedRows);
    }

    //清空列表选中
    const clearSelect = () => {
        setSelectedRowKeys([]);
        setCheckboxState([]);
    }

    const rowSelection = {
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
    }

    const columns = [
        {
            title: 'Department',
            dataIndex: 'deptId',
            className: 'tableWidth35',
            render: text => deptList.map(item => item.deptId === text && item.deptCode + '-' + item.deptDisplayName)
        },
        {
            title: trans.progCode[Config.backLang],
            dataIndex: 'progCode',
            className: 'tableWidth25',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progCode') },
        },
        {
            title: trans.progTitle[Config.backLang],
            dataIndex: 'progTitle',
            className: 'tableWidth25',
        },
        {
            title: trans.progLaunchYear[Config.backLang],
            dataIndex: 'progLaunchYear',
            className: 'tableWidth15',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progLaunchYear') },
        },
    ];
    return (
        <Modal className="selectProgramme"
            visible={true}
            title="Select Programme"//标题
            centered//垂直居中
            closable//是否显示右上角的关闭按钮
            maskClosable={false}//点击蒙层是否允许关闭    
            width={'1228px'}
            onCancel={() => props.onClose(false)}
            footer={[
                <Button key='save' className='sysBtn btnBlue' type="primary" onClick={save} icon={<CheckCircleOutlined />}>{trans.select[Config.backLang]}</Button>,
                <Button key='cancel' className="sysBtn" onClick={() => props.onClose(false)} icon={<CloseCircleOutlined />}>{trans.cancel[Config.backLang]}</Button>
            ]}
        >
            <Spin size="large" spinning={isLoad} tip={trans.beQuerying[Config.backLang]}>
                <Message ref={messageRef} />
                <div className='sysSearchRow'>
                    <div className='sysRow'>
                        <div className='sysCol'>
                            <div className="sysTitle">{trans.deptCode[Config.backLang]}</div>
                            <div className="sysSerchInput">
                                <Select className="sysSelect" placeholder={trans.deptCode[Config.backLang]}
                                    value={searchModel.deptId || ''}
                                    onChange={(e) => searchChange('deptId', e)}
                                >
                                    <Option value=""></Option>
                                    {deptList.map((item) => <Option key={item.deptId} value={item.deptId}>{item.deptCode + '-' + item.deptDisplayName}</Option>)}
                                </Select>
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">{trans.progCode[Config.backLang]}</div>
                            <div className="sysSerchInput">
                                <Input type="text" value={searchModel.progCode || ''}
                                    placeholder={trans.progCode[Config.backLang]}
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('progCode', e.target.value)} />
                            </div>
                        </div>
                        <div className='sysCol'>
                            <div className="sysTitle">{trans.progTitle[Config.backLang]}</div>
                            <div className="sysSerchInput">
                                <Input type="text" value={searchModel.progTitle || ''}
                                    placeholder={trans.progTitle[Config.backLang]}
                                    onKeyDown={(e) => e.key === "Enter" ? search(pageSize, 1, "N", true) : null}
                                    onChange={(e) => searchChange('progTitle', e.target.value)} />
                            </div>
                        </div>
                        <div className='sysSearchButton'>
                            <Button className="sysBtn btnBlue" type="primary" onClick={() => search(pageSize, 1, "N", true)} hidden={Config.funcInfo.canSelect === "N"} icon={<SearchOutlined />}>{trans.search[Config.backLang]}</Button>
                            <Button className="sysBtn" onClick={reset} icon={<RedoOutlined />}>{trans.reset[Config.backLang]}</Button>
                        </div>
                    </div>
                </div>
                <div className="sysLineEight"></div>
                <div className="sysTable" id="tableOne">
                    <Table
                        rowSelection={rowSelection}
                        scroll={{ x: 1000 }}
                        rowKey="progId" //Key值
                        columns={columns} //列名
                        dataSource={tables} //数据
                        pagination={{  //分页
                            showSizeChanger: true,    //是否显示可以设置几条一页的选项
                            onChange: onChange,       //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange, //每页显示条数方法
                            total: tablesCount,        //总共多少条数据
                            current: current,       //当前页
                            pageSize: pageSize,  //每页显示多少条数据
                            defaultCurrent: 1, //默认当前页为1
                            size: "small"
                        }}
                        onRow={(record) => {
                            return {
                                onClick: event => Base.selectRowNew.call(this, record, 'progId', checkboxState, selectedRowKeys, setCheckboxState, setSelectedRowKeys),
                            };
                        }}
                    />
                </div>
            </Spin>
        </Modal>
    )

}

SelectProgramme.propTypes = {
    onClose: PropTypes.func.isRequired,
    checkboxState: PropTypes.array,
}

export default SelectProgramme;